import { Component, Input } from '@angular/core';
import { StatusBadgeType } from '../status-badge/status-badge-code';
import {
  EBookingPaymentStatus,
  PAYMENT_STATUS_BADGE_TYPE,
} from './payment-status.types';

/** Status badge for a booking's payment status; the label is the backend's localized paymentStatusTitle. */
@Component({
  selector: 'app-payment-status-badge',
  template: `@if (label) {
      <app-status-badge [type]="badgeType" [label]="label"></app-status-badge>
    } @else {
      -
    }`,
  standalone: false,
})
export class PaymentStatusBadgeComponent {
  @Input() statusId: EBookingPaymentStatus | null | undefined;
  @Input() label = '';

  get badgeType(): StatusBadgeType {
    return this.statusId == null
      ? 'default'
      : (PAYMENT_STATUS_BADGE_TYPE[this.statusId] ?? 'default');
  }
}
